import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

import { showGeofencingPopupAction } from '../actions';

export const useRunBrowserGeolocation = ({
    useTransparentPopup
}: {
    useTransparentPopup: boolean;
}) => {
    const dispatch = useDispatch();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const closePopups = useSmartClosePopups();

    return useCallback(async () => {
        try {
            return await new Promise<GeolocationPosition>((resolve, reject) => {
                if (!navigator.geolocation) {
                    reject();
                    return;
                }

                navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => resolve(position), reject, {
                    timeout: 10000
                });
            });
        } catch (error: any) {
            if (error?.code === window.GeolocationPositionError?.PERMISSION_DENIED) {
                dispatch(showGeofencingPopupAction({
                    title: 'playtech.mobile.system.geocomply.popups.geolocationNotAvailable.title',
                    content: 'playtech.mobile.system.geocomply.popups.geolocationNotAvailable.content',
                    isModal: true,
                    buttons: [
                        {
                            onClick: () => closePopups(),
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        },
                        {
                            onClick: onRefresh,
                            text: 'playtech.mobile.system.geocomply.popups.error.refresh',
                            color: 'info'
                        }
                    ],
                    useTransparentPopup
                }));
            }

            throw error;
        }
    }, [
        dispatch,
        onRefresh,
        closePopups,
        useTransparentPopup
    ]);
};
